module.exports = __webpack_public_path__ + "img/location-blue.42ec60a8.svg";